/** 
 * @packageDocumentation
 * @module ErBsClient
 **/

export enum GameModes {
	Solo = 1,
	Duos = 2,
	Squads = 3
}
